export default "__VITE_ASSET__mStwkTZ4__"